import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import NavigationBar from '../../components/ui/NavigationBar';
import NewHeroSection from './components/NewHeroSection';
import LogoCloudSection from './components/LogoCloudSection';
import { Component as ReadingTextReveal } from '../../components/ui/reading-text-reveal';
import { FeatureCarousel } from '../../components/ui/FeatureCarousel';
import IdentitySpotlight from './components/IdentitySpotlight';
import ProjectsSection from './components/ProjectsSection';
import StackingCardsShowcase from './components/StackingCardsShowcase';
import VisioneerSection from './components/VisioneerSection';
import FeatureShowcase from './components/FeatureShowcase';
import CoursePreview from './components/CoursePreview';
import { BlogSection } from '../../components/ui/blog-section';
import { StickyFooter } from '../../components/ui/sticky-footer';

const HomeLandingPage = () => {
  useEffect(() => {
    // Scroll to top on page load
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Nesolearn - AI-Powered Learning Platform | Learn. Build. Earn.</title>
        <meta 
          name="description" 
          content="Transform your career with AI-powered education. Master cutting-edge skills, earn valuable certifications, and lead the future of technology with Nesolearn." 
        />
        <meta name="keywords" content="AI learning, machine learning courses, online education, certificates, skill development" />
        <meta property="og:title" content="Nesolearn - AI-Powered Learning Platform" />
        <meta property="og:description" content="Learn. Build. Earn. Transform your career with AI-powered education." />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="/home-landing-page" />
      </Helmet>

                  <div className="min-h-screen w-full overflow-x-hidden bg-white">
        {/* Navigation */}
        <NavigationBar />

        {/* Main Content */}
        <main>
                    {/* Hero Section */}
          <NewHeroSection />

          {/* Logo Cloud */}
          <LogoCloudSection />

          {/* Reading Text Reveal */}
          <ReadingTextReveal />

                    {/* Feature Carousel */}
          <div className="flex items-center justify-center w-full py-16 bg-background px-4 md:px-8">
            <FeatureCarousel />
          </div>

                    {/* Identity Spotlight */}
          <IdentitySpotlight />

                              {/* Projects */}
          <ProjectsSection />

                    {/* Stacking Cards */}
          <StackingCardsShowcase />

          {/* Feature Showcase */}
          <FeatureShowcase />

          {/* Visioneer */}
          <VisioneerSection />

                    {/* Course Preview */}
          <CoursePreview />

          {/* Blog */}
          <div className="flex justify-center w-full py-16 bg-background px-4 md:px-8">
            <BlogSection />
          </div>
        </main>

        {/* Footer */}
        <StickyFooter />
      </div>
    </>
  );
};

export default HomeLandingPage;
